<template>
    <div>
        <config-main-title>
            {{ titulo (false) }}
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6">
                    <az-input icon="fas fa-search" v-model="search" @input="buscarItems ()">
                        <template v-slot:buttonposb>
                            <importacao :service="service_importacao" @refresh="load()" />
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'; dados = null; load(1)">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'; dados = null; load(1)">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir {{ titulo () }}
                    </button>
                </div>
            </div>

        </div>

        <div v-if="!lista || !lista.length">
            <az-empty-state 
                :msg="'Nenhum ' + titulo () + ' Identificado.'" 
                icon="fas fa-search"
                :action="'Incluir ' + titulo ()" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <span class="badge badge-secondary" v-if="dado && dado['id_' + model]">#{{ dado['id_' + model] }}</span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.unidade.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <span v-if="dado.js_classes">
                                <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                    v-for="(tag, itx) in dado.js_classes" :key="itx">
                                    <span class="badge badge-success ml-1">
                                        {{ tag }}
                                    </span>
                                </a>
                            </span>

                            <span class="badge badge-primary ml-2" v-if="dado.fl_opme">
                                OPME
                            </span>

                            <span class="badge badge-secondary ml-2" v-if="dado.unidade_medida">
                                {{ dado.unidade_medida.st_termo }}
                            </span>

                            <span class="badge badge-secondary ml-2" v-if="dado.st_codigo">
                                {{ dado.st_codigo }}
                            </span>

                            <a href="#" @click.prevent="editar_consumos(dado)" v-if="medicamentos || kits">
                                <span class="badge badge-primary ml-2">
                                    <i class="fa fa-shopping-cart mr-1" aria-hidden="true"></i>
                                    {{ dado.consumos.length }}
                                </span>
                            </a>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item['id_' + model] ? '' : 'Novo' }}
                            {{ titulo () }} 
                            <span class="badge badge-secondary" v-if="item && item['id_' + model]">#{{ item['id_' + model] }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12" :class="kits ? 'col-md-9' : 'col-md-6'">
                                <az-input
                                    v-if="kits"
                                    label="Nome"
                                    required 
                                    :validate="validate"
                                    v-model="item.st_medicamento" />

                                <az-input
                                    v-else
                                    label="Nome"
                                    required 
                                    :validate="validate"
                                    v-model="item['st_' + model]" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Código Externo"
                                    :validate="validate"
                                    v-model="item.st_id_externo" />
                            </div>
                            <div class="col col-12 col-md-3" v-if="!kits">
                                <az-input
                                    :label="taxas ? 'Código TUSS' : 'Código Faturamento'"
                                    :validate="validate"
                                    v-model="item.st_codigo" />
                            </div>
                        </div>

                        <div class="row" v-if="!taxas && !kits">
                            <div class="col col-12 col-md-6">
                                <!-- && !medicamentos -->
                                <az-input
                                    v-if="!taxas && !kits"
                                    label="Código SIMPRO"
                                    v-model="item.st_codigo_simpro" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Unidade de Medida (TISS)"
                                    placeholder="Unidade"
                                    :validate="validate"
                                    type="select"
                                    optionsMode="aql"
                                    service="unidade_medidas.index"
                                    optionsData="id_unidade_medida"
                                    optionsDisplay="search"
                                    v-model="item.id_unidade_medida" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Preço de Custo"
                                    :validate="validate"
                                    type="money"
                                    precision2="6"
                                    v-model="item.dc_preco_custo" />
                            </div>
                        </div>

                        <div class="row mt-3" v-if="!taxas && !kits">
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="OPME"
                                    v-model="item.fl_opme" />
                            </div>
                        </div>

                        <div class="mt-3">
                            <multiselect
                                v-model="item.js_classes"
                                :options="options_classes"
                                :multiple="true"
                                :taggable="true"
                                @tag="addTag"
                                placeholder="Selecione uma classificação..."
                                selectLabel="Pressione [ENTER] para selecionar"
                                deselectLabel="Pressione [ENTER] para remover"
                                tagPlaceholder="Pressione [ENTER] para incluir"
                                selectedLabel="Selecionado">
                                <template slot="noOptions">
                                    Nenhuma região selecionado.
                                </template>
                            </multiselect>
                        </div>

                        <table class="table table-sm table-hover small mt-3" v-if="item.cod_simpros && item.cod_simpros.length">
                            <thead>
                                <tr>
                                    <th>Tabela Simpro</th>
                                    <th>Código</th>
                                    <th>TUSS</th>
                                    <th>Descrição</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(simpro, isx) in item.cod_simpros">
                                    <tr :key="isx" v-if="true">
                                        <td><span v-if="simpro.tabela_versao">{{ simpro.tabela_versao.st_nome }}</span></td>
                                        <td>{{ simpro.st_codigo_simpro }}</td>
                                        <td>{{ simpro.st_codigo_tuss }}</td>
                                        <td>{{ simpro.st_descricao }}</td>
                                        <td class="text-right">
                                            <div class="dropdown dropleft" v-if="item.id_material || item.id_medicamento">
                                                <a class="card-link" type="button" data-toggle="dropdown" aria-expanded="false">
                                                    <i class="fa-solid fa-pen-to-square text-primary"></i>
                                                </a>
                                                <div class="dropdown-menu">
                                                    <a class="dropdown-item" href="#" @click.prevent="atualizar_simpro(item, simpro, 'S')">Atualizar Tabelas com Atualização Simpro</a>
                                                    <a class="dropdown-item" href="#" @click.prevent="atualizar_simpro(item, simpro, 'T')">Atualizar Tabelas com Simpro: {{ simpro.tabela_versao.st_nome }}</a>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>

                        <table class="table table-sm table-hover small mt-3" v-if="item.cod_brasindices && item.cod_brasindices.length">
                            <thead>
                                <tr>
                                    <th>Tabela Brasíndice</th>
                                    <th>TUSS</th>
                                    <th>Descrição</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(brasindice, isx) in item.cod_brasindices">
                                    <tr :key="isx" v-if="true">
                                        <td><span v-if="brasindice.tabela_versao">{{ brasindice.tabela_versao.st_nome }}</span></td>
                                        <td>{{ brasindice.st_codigo_tuss }}</td>
                                        <td>{{ brasindice.search }}</td>
                                        <td class="text-right">
                                            <div class="dropdown dropleft" v-if="item.id_material || item.id_medicamento">
                                                <a class="card-link" type="button" data-toggle="dropdown" aria-expanded="false">
                                                    <i class="fa-solid fa-pen-to-square text-primary"></i>
                                                </a>
                                                <div class="dropdown-menu">
                                                    <a class="dropdown-item" href="#" @click.prevent="atualizar_brasindice(item, brasindice, 'S')">Atualizar Tabelas com Atualização Brasíndice</a>
                                                    <a class="dropdown-item" href="#" @click.prevent="atualizar_brasindice(item, brasindice, 'T')">Atualizar Tabelas com Brasíndice: {{ brasindice.tabela_versao.st_nome }}</a>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>

                        <div v-if="!kits && taxa_item_tabelas && taxa_item_tabelas.length && ( item && item['id_' + model] )">

                            <az-sub-title class="mt-3" title="Identificação nas Tabelas" />

                            <!-- Tabelas -->
                             <table class="table table-sm table-striped">
                                <tr v-for="(tabela, iti) in taxa_item_tabelas" :key="iti">
                                    <td>
                                        <div class="form-row mb-0">
                                            <div class="col col-12 col-md-4">
                                                <a href="#" class="text-primary card-link" @click.prevent="acessarTabela (tabela, tabela.consumo_item_tabela.item_tabela)" teste="$util.abrirTabela(tabela)">
                                                    {{ tabela.st_nome + ' - ' + tabela.st_versao }}
                                                </a>
                                            </div>
                                            <div class="col col-12 col-md-8">
                                                <az-input   
                                                    :mb="false"
                                                    sizing="sm"
                                                    type="autocomplete" 
                                                    :service="service (tabela)"
                                                    :optionsParm="{ id_tabela_versao: tabela.id_tabela_versao }"
                                                    optionsMode="aql" 
                                                    v-model="tabela.consumo_item_tabela.item_tabela">
                                                    <template v-slot:buttonposb v-if="tabela.consumo_item_tabela.item_tabela">
                                                        <div class="input-group-append">
                                                            <span class="input-group-text small text-muted">#{{ tabela.consumo_item_tabela.item_tabela.id_propria ? tabela.consumo_item_tabela.item_tabela.id_propria : tabela.consumo_item_tabela.item_tabela.id_item_tabela }}</span>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                             </table>

                            <pre v-if="1 == 0">{{ taxa_item_tabelas }}</pre>

                        </div>

                        <div v-if="!kits && item.estoque_items && item.estoque_items.length">

                            <az-sub-title class="mt-3" title="Suprimentos / Cobrança" />
 
                            <table class="table table-sm mt-3 small">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Descrição</th>
                                        <th>Unidade de Medida</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ei, ie) in item.estoque_items" :key="ie">
                                        <td>#{{ ei.id_estoque_item }}</td>
                                        <td>{{ ei.st_estoque_item }}</td>
                                        <td>{{ ei.st_unidade_estoque }}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                        <br><br><br><br><br><br>

                        
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button :model="model" :id="item['id_' + model]" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item && item['id_' + model] ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="consumosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document" v-if="medicamentos || kits">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Cobrança Adicional: {{ item.search }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item.consumos">

                        <div class="row" v-for="(comp, icx) in lista_consumo" :key="icx">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    icon="fa fa-minus fa-fw"
                                    :buttonIcon="true"
                                    buttonColor="outline-danger"
                                    buttonText="fa fa-minus fa-fw"
                                    @clickButton="comp.excluido = true"
                                    :edicao="false"
                                    v-model="comp.search" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    type="number"
                                    :validate="validate"
                                    v-model="comp.dc_quantidade"
                                    :iconEnd="{ 
                                        color: comp.consumo_procedimento_operadoras.length ? 'outline-primary' : 'outline-secondary', 
                                        icon: 'far fa-credit-card', 
                                        tooltip: 'Configurações por Operadora' 
                                    }"
                                    @clickButtonEnd="configurarPorOperadora(comp)" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Não Repetir"
                                    type="checkbox-group"
                                    labelClass="lead"
                                    :validate="validate"
                                    v-model="comp.fl_nao_repetir" />
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col">
                                <az-input
                                    icon="fa fa-plus fa-fw"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    optionsName="consumo.index" 
                                    :optionsParm="{ medicamentos: true }"
                                    service="consumo.index"
                                    :optionsSync="true"
                                    v-model="novoComponente"
                                    @input="incluirComponente ()" />
                            </div>
                        </div>

                        <br><br><br><br><br>
                        <br><br><br><br><br>

                        <pre v-if="false">{{ item }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_consumos()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="consumoOperadoraModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="edicaoConsumoProcedimento">
                    <div class="modal-header">
                        <h5 class="modal-title">Configurações por Operadora</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <h5 class="text-primary">{{ edicaoConsumoProcedimento.search }}</h5>

                        <div class="row" v-for="(cpo, icpo) in lista_consumo_operadora" :key="icpo">
                            <div class="col col-12 col-md-9">
                                <az-input
                                    icon="fa fa-minus fa-fw"
                                    :buttonIcon="true"
                                    buttonColor="outline-danger"
                                    buttonText="fa fa-minus fa-fw"
                                    @clickButton="cpo.excluido = true"
                                    :edicao="false"
                                    v-if="cpo.id_plano"
                                    v-model="cpo.plano.search">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">P</span>
                                        </div>
                                    </template>
                                </az-input>

                                <az-input
                                    icon="fa fa-minus fa-fw"
                                    :buttonIcon="true"
                                    buttonColor="outline-danger"
                                    buttonText="fa fa-minus fa-fw"
                                    @clickButton="cpo.excluido = true"
                                    :edicao="false"
                                    v-else
                                    v-model="cpo.operadora.search">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">O</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    type="number"
                                    v-model="cpo.in_quantidade" />
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col">
                                <az-input
                                    type="button-group"
                                    :optionsList="[
                                        { id: 'O', search: 'Operadora' },
                                        { id: 'P', search: 'Particular' }
                                    ]"
                                    optionsData="id"
                                    optionsDisplay="search"
                                    v-model="novaOperadoraTipo" />
                            </div>
                        </div>

                        <div class="row mt-2" v-if="novaOperadoraTipo == 'O'">
                            <div class="col">
                                <az-input
                                    icon="fa fa-plus fa-fw"
                                    label="Operadora"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    optionsName="operadoras.index" 
                                    service="operadoras.index"
                                    :optionsSync="true"
                                    v-model="novaOperadora"
                                    @input="incluirOperadora ()" />
                            </div>
                        </div>

                        <div class="row mt-2" v-else-if="novaOperadoraTipo == 'P'">
                            <div class="col">
                                <az-input
                                    icon="fa fa-plus fa-fw"
                                    label="Particular"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    optionsName="planos.particular.index" 
                                    :optionsParm="{ particular: true }"
                                    service="planos.index"
                                    @input="incluirOperadoraPlano ()"
                                    v-model="novaOperadoraPlano" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="confirmarConfiguracaoPorOperadora ()">OK</button>
                    </div>
                </div>
            </div>
        </div>

        <br><br><br><br><br>

        <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.data">
            <div class="d-flex">
                <template v-if="dados.last_page > 1">
                    <paginate
                        class="mb-0"
                        :page-count="dados.last_page"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-link'"
                        :next-class="'page-link'"
                        :prev-text="'<<'"
                        :next-text="'>>'"
                        :click-handler="paginar">
                    </paginate>
                </template>

                <div class="spinner-border ml-2" role="status" v-if="$store.state.loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div>
                <span>
                    {{ lista.length }} / {{ dados.total }}
                </span>
            </div>
        </nav>

        <cadastro-item-tabela ref="cadtab" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import Importacao from '../shared/Importacao.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import CadastroItemTabela from '../shared/CadastroItemTabela.vue';
import Multiselect from 'vue-multiselect';


export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            procedimentos: null, 
            validate: false,
            especialidade: null,
            search: "", 
            viewMode: "A",
            taxa_item_tabelas: [], 
            novoComponente: null, 
            novaOperadora: null,
            consumoProcedimento: null,
            edicaoConsumoProcedimento: null,
            novaOperadoraPlano: null, 
            novaOperadoraTipo: 'O',
            page: 1, 
            pesquisar_debounce: null, 
            options_classes: [], 
        }
    },

    props: ['medicamentos', 'taxas', 'kits'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzSubTitle, 
        Importacao, 
        AzAuditLogButton, 
        CadastroItemTabela, 
        Multiselect,
    },

    computed: { 
        lista_consumo_operadora () { 

            if ( !this.edicaoConsumoProcedimento || !this.edicaoConsumoProcedimento.consumo_procedimento_operadoras )
                return [];

            return this.edicaoConsumoProcedimento.consumo_procedimento_operadoras.filter(item => !item.excluido);

        },

        model: function () { 
            return ( this.medicamentos || this.kits ) 
                ? 'medicamento' 
                : ( this.taxas ? 'taxa' : 'material' );
        },

        service_importacao: function () { 
            return ( this.medicamentos || this.kits ) 
                ? 'medicamentos' 
                : ( this.taxas ? 'taxas' : 'materiais' );
        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return ( this.dados && this.dados.data && this.dados.data.length ) ? 
                this.dados.data.filter (item => { 
                    return ( this.viewMode == 'T' || item.unidade.fl_ativo ) && 
                        ( true || !this.search || reg.test(JSON.stringify(item)) );
                })
                .sort((a, b) => { 
                    return a.search > b.search ? 1 : -1 ;
                }) : [];
        },

        lista_consumo: function () { 

            if ( !this.item || !this.item.consumos )
                return [];

            return this.item.consumos.filter(item => !item.excluido);

        },

        service_name: function () { 
            if ( this.medicamentos || this.kits ) 
                return 'medicamentos';

            if ( this.taxas ) 
                return 'taxas';

            return 'materiais';
        }
    },

    methods: { 
        atualizar_simpro (item, simpro, tipo) { 
            this.$util.atualizar(this, { 
                service: 'tabelas',
                func: 'atualizar_simpro_tabelas', 
                dados: { 
                    id_material: item.id_material,
                    id_medicamento: item.id_medicamento,
                    id_simpro: simpro.id_simpro,
                    tipo: tipo,  
                }
            });
        },

        atualizar_brasindice (item, brasindice, tipo) { 
            this.$util.atualizar(this, { 
                service: 'tabelas',
                func: 'atualizar_brasindice_tabelas', 
                dados: { 
                    id_material: item.id_material,
                    id_medicamento: item.id_medicamento,
                    id_brasindice: brasindice.id_brasindice,
                    tipo: tipo,  
                }
            });
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        refreshItem () { 
            this.editar(this.item);
        },

        acessarTabela (tabela, item) {
            console.log('tabela', tabela);
            console.log('item', item);
            console.log('this.item', this.item);

            if ( !item ) {
                this.$refs.cadtab.incluirItemParaModel(tabela, this.item, this.model,this.refreshItem);
            } else {
                this.$refs.cadtab.abrirItemTabela(item.id_item_tabela ? item.id_item_tabela : item.id_propria, this.refreshItem, tabela);
            }
        },

        incluirItem () { 
            this.$refs.cadtab.incluirItem (this.tabela, this.reloadItems);
        },

        editarItem (item) { 
            this.$refs.cadtab.abrirItemTabela (item.id_item_tabela ? item.id_item_tabela : item.id_propria, this.reloadItems, this.tabela);
        },

        buscarItems () {
            if ( this.pesquisar_debounce )
                clearTimeout(this.pesquisar_debounce);

            this.pesquisar_debounce = setTimeout(() => {
                this.page = 1;
                this.load();
                clearTimeout(this.pesquisar_debounce);
            }, 300);
        },

        paginar (page) {
            this.page = page;
            this.load();
        },

        incluirOperadora () { 
            if ( !this.novaOperadora ) 
                return;

            this.edicaoConsumoProcedimento.consumo_procedimento_operadoras.push({ 
                id_consumo_procedimento_operadora: null, 
                id_operadora: this.novaOperadora.id_operadora,
                id_consumo_procedimento: this.consumoProcedimento.id_consumo_procedimento,
                in_quantidade: this.consumoProcedimento.dc_quantidade,
                excluido: false, 
                operadora: { 
                    search: this.novaOperadora.search, 
                }
            });

            this.novaOperadora = "";

            this.$nextTick(() => { 
                this.novaOperadora = null;
            });

        },
        
        incluirOperadoraPlano () { 
            if ( !this.novaOperadoraPlano ) 
                return;

            this.edicaoConsumoProcedimento.consumo_procedimento_operadoras.push({ 
                id_consumo_procedimento_operadora: null, 
                id_operadora: this.novaOperadoraPlano.id_operadora,
                id_plano: this.novaOperadoraPlano.id_plano,
                id_consumo_procedimento: this.consumoProcedimento.id_consumo_procedimento,
                in_quantidade: this.consumoProcedimento.dc_quantidade,
                excluido: false, 
                operadora: { 
                    search: this.novaOperadoraPlano.search, 
                }, 
                plano: { 
                    search: this.novaOperadoraPlano.search, 
                },
            });

            this.novaOperadoraPlano = "";

            this.$nextTick(() => { 
                this.novaOperadoraPlano = null;
            });

        },

        configurarPorOperadora (item) { 
            this.novaOperadora = null;
            this.consumoProcedimento = item;
            this.edicaoConsumoProcedimento = { ...item };

            $('[data-toggle="tooltip"]').tooltip('dispose');

            $('#consumoOperadoraModal').modal('show');
        },

        confirmarConfiguracaoPorOperadora () { 
            this.consumoProcedimento.consumo_procedimento_operadoras = this.edicaoConsumoProcedimento.consumo_procedimento_operadoras;

            $('#consumoOperadoraModal').modal('hide');
        },

        salvar_consumos() { 
            this.$util.atualizar(this, { 
                service: 'consumo',
                func: 'store',
                dados: this.item,
                modal: 'consumosModal', 
                toast: true, 
                reload: true,
            });
        },

        incluirComponente() { 
            if ( !this.novoComponente ) 
                return;

            let novo = _.cloneDeep(this.novoComponente);
            this.novoComponente = "";

            this.item.consumos.push({ 
                id_consumo_procedimento: null, 
                id_medicamento: this.item.id_medicamento,
                id_taxa: novo.id_taxa,
                id_material: novo.id_material,
                id_medicamento_item: novo.id_medicamento, 
                id_procedimento_item: novo.id_procedimento,
                dc_quantidade: 1,
                fl_nao_repetir: false,
                search: novo.search,
                excluido: false, 
                consumo_procedimento_operadoras: [], 
            });

            this.$nextTick(() => { 
                this.novoComponente = null;
            });
        },

        service (tabela) { 

            return this.taxas ? 'item_tabelas.index' : 
                    ( tabela.ch_tipo_tabela == 'B' ? 'brasindices.index' : 
                        ( tabela.ch_tipo_tabela == 'S' ? 'simpros.index' : 'proprias.index' ) ) ;

        },

        titulo (singular = true) { 
            if ( singular ) { 
                if ( this.medicamentos )    
                    return 'Medicamento';
                
                if( this.taxas ) 
                    return 'Taxa';

                if ( this.kits )
                    return 'Kit';

                return 'Material';
            } else { 
                if ( this.medicamentos )    
                    return 'Medicamentos';
                
                if( this.taxas ) 
                    return 'Taxas';

                if ( this.kits )
                    return 'Kits de Mat/Med/Taxas';

                return 'Materiais';
            }
        },
        incluir () { 
            this.validate = false;

            let item = {
                unidade: { 
                    fl_ativo: true, 
                },
                id_unidade_medida: null, 
                js_classes: [], 
                fl_kit: this.kits ? true : false, 
                id_tabela_versao_sim: "", 
                id_simpro: "", 
            };

            item['id_' + this.model] = null;
            item['st_' + this.model] =  "";

            this.editar (item);
        },
        load (page) { 
            if ( page )
                this.page = page;

            this.$util.load (this, { 
                service: this.service_name, 
                parms: { 
                    cadastro: true, 
                    size: 200,
                    page: this.page, 
                    busca: this.search, 
                    ativos: this.viewMode == 'A' ? true : false, 
                    cad_kits: this.kits ? true : false,
                }
            });
        },

        editar_consumos (item) { 
            this.item = null;

            this.$nextTick(() => { 
                this.item = _.cloneDeep (item);
                $('#consumosModal').modal('show');
            });
        },

        editar (item) { 
            this.item = null;

            this.$nextTick(() => { 

                this.validate = false;

                this.$util.loadItem(this, { 
                    service: 'tabela_versaos',
                    func: 'index',
                    parms: { 
                        id_taxa: item.id_taxa ? item.id_taxa : -1,
                        cadastro_taxas: this.taxas,
                        id_medicamento: item.id_medicamento, 
                        cadastro_medicamentos: this.medicamentos,
                        id_material: item.id_material, 
                        cadastro_materiais: !this.taxas && !this.medicamentos, 
                    }
                })
                .then(res => { 
                    if ( !res.js_classes ) {
                        res.js_classes = [];
                    }

                    this.taxa_item_tabelas = res;
                    this.item = _.cloneDeep (item);
                    $('#edicaoModal').modal('show');
                });

            });

            return;

        },
        atualizar () { 
            this.$util.atualizar (this, { 
                service: this.service_name,
                dados: { 
                    ...this.item,
                    consumo_tabelas: this.taxa_item_tabelas, 
                },
                reload: true,
                modal: 'edicaoModal',
            });
        },
        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle (this, { 
                service: ( this.medicamentos || this.kits ) ? 'medicamento_unidades' : ( this.taxas ? 'taxa_unidades' : 'material_unidades' ), 
                dados: { ...item.unidade }, 
            });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: this.titulo (true), method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.loadItem(this, { 
            service: this.service_name,
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>